<template>
  <div
    class="preference-container"
    :class="{ showingSideBar: isPreferenceVisible }"
  >
    <div class="tab-preference-container">
      <div class="tab-preference-label-notification">
        <div class="preference__item__text">
          PREFERÊNCIAS DE USUÁRIO
        </div>
      </div>
    </div>

    <div v-if="preferencesVisible">
      <div
        v-for="(preference, rowIndex) in preferences"
        :key="rowIndex"
        class="preference-container__options"
      >
        <template v-if="checkFeatureToggle(preference.name)">
          <md-layout
            md-flex="15"
            md-flex-medium="20"
          >
            <md-switch
              v-model="preference.enabled"
              :name="preference.name"
              class="md-primary"
            >
              {{ preference.description }}
            </md-switch>
          </md-layout>
          <md-layout
            v-if="preference.enabled && preference.values.length > 2"
            md-flex="15"
            class="itemSelect"
            md-flex-medium="20"
          >
            <model-list-select
              :id="preference.name"
              v-model="preference.value"
              v-validate="'required'"
              option-text="label"
              class="combo-box"
              placeholder="Selecione uma opção"
              :options="options(preference)"
              option-value="userPreferenceValueId"
            >
              <span slot="no-options">Nenhuma opção encontrada para essa busca.</span>
            </model-list-select>
          </md-layout>
        </template>
      </div>
    </div>

    <spinner v-else />

    <div class="button-container">
      <button
        :disabled="preferencesLoading === 'STATUS_LOADING'"
        class="btn btn-primary btn-medium"
        @click="editUserPreference(preferences)"
      >
        <span v-if="preferencesLoading === 'STATUS_END' || preferencesLoading === 'STATUS_INITIAL'">Salvar</span>
        <span v-else>Salvando preferências</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Spinner from '@/components/common/Spinner'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import strings from '../../strings'
import { deepCloneObj } from '@/utils/object-utils'
import { mergeTwoArraysOfObjects } from '../../utils/mergeTwoArraysOfObjects'

export default {
  name: 'PreferenceBar',
  components: {
    'advanced-select': AdvancedSelect,
    'spinner': Spinner
  },
  data: () => {
    return {
      preferences: []
    }
  },
  computed: {
    ...mapGetters(['isPreferenceVisible', 'preferencesWithOptions', 'profile', 'preferencesLoading', 'toggle']),
    preferencesVisible: function () {
      return (this.preferencesLoading === 'STATUS_END' && this.preferences.length > 0)
    }
  },
  watch: {
    preferencesLoading: function (newValue) {
      if (newValue === 'STATUS_INITIAL') {
        this.getPreferencesOptions()
      }
    },
    preferencesWithOptions: function () {
      this.copyUserPreferences()
    }
  },
  created() {
    this.getPreferencesOptions()
    this.preferences = this.preferencesWithOptions
  },
  methods: {
    ...mapActions(['editUserPreference', 'getPreferencesOptions']),
    options(preference) {
      let labels = strings[preference.name]
      let values = preference.values
      return mergeTwoArraysOfObjects(labels, values)
    },
    checkFeatureToggle(name) {
      return (this.toggle[name] !== null && this.toggle[name] !== undefined) ? this.toggle[name] : true
    },
    copyUserPreferences() {
      this.preferences = deepCloneObj(this.preferencesWithOptions)
    }
  }
}
</script>
<style lang="scss">
@import '../../../static/stylesheets/variables';

.preference-container {
  background-color: #F4F4F4;
  width: 0;
  flex-grow: 0;
  margin-top: $mainHeaderHeight;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 104;
  border-left: 1px solid #e2e2e2;
  box-shadow: 10px 10px 17px grey;
  transition: width .3s;
  transition-delay: .15s;
  height: 100%;
  overflow: hidden;

  .tab-preference-container {
    display: flex;
  }

  .combo-box {
    width: 90%;
    margin-left: 3em;
    background-color: white;
    border-radius: 10px;
    padding: 5px 10px;
  }

  .v-select .vs__selected,
  .v-select input[type="search"],
  .v-select input[type="search"]:focus {
    color: #2a2a2a;
    text-align: left;
    font-size: 12px;
    font-weight: 450;
    letter-spacing: 1px;
    text-transform: unset;
    padding-top: 5px;
    margin: 0px;
  }

  .v-select .selected-tag {
    color: #7a7a7a
  }

  .v-select.dropdown.open .dropdown-toggle,
  .v-select.dropdown.open .dropdown-menu {
    text-transform: unset;
  }

  .clear {
    display: none;
  }

  .button-container {
    margin: 2em 2em;
  }

  .preference__item__text {
    opacity: 1;
    margin: auto;
    width: 100%;
    font-size: 15px;
    font-weight: 900;
    line-height: 1.17;
    letter-spacing: 0.5px;
    text-align: center;
  }

  .itemSelect {
    font-size: 14px;
    font-family: Roboto, sans-serif;
    margin-top: 2px;
  }

  .tab-preference-label-notification {
    display: flex;
    align-items: center;
    padding: 20px 30px 15px 30px;
    border-bottom-style: solid;
    border-bottom-width: 7px;
    width: 100%;
    border-bottom-color: #F4F4F4;
    color: #9C9C9C;
  }

  &.showingSideBar {
    width: 400px;
    transition: width .3s;
  }

  &__options {
    padding: 10px 30px;

    label {
      font-family: Roboto, sans-serif;
      font-weight: 400;
      line-height: 20px;
      word-wrap: unset;
      white-space: normal;
      word-break: keep-all;
      position: fixed;
      width: 50%;
      height: auto;
      font-size: 14px;
    }
  }

  .md-input-container {
    width: 60%;
    margin-left: 3em;
  }

  .advanced-select__container .multiselect__single {
    padding: 1px 0 0;
    background: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
    padding-top: 8px;
    width: -webkit-fill-available;
  }

  .md-switch .md-switch-label {
    height: 14px;
    margin-left: 47px;
    line-height: 14px;
    width: auto;
  }

  .v-select input[type=search],
  .v-select input[type=search]:focus {
    margin: 0 0 0;
    font-family: Roboto, sans-serif;
    font-size: 14px;
  }

  .v-select .selected-tag {
    font-size: 14px;
  }
}
</style>
